import { Component, Vue } from 'vue-property-decorator';
import { IPolicy, ITask, IUser, PolicyStatus, TaskStatus } from 'admiral-core';
import { Util } from '@/utils/Util';

@Component
export class FormatMixin extends Vue {
  tagClasses = ['primary', 'secondary', 'success', 'warning', 'danger', 'info'];

  formatStatusLabel(policyOrStatus: IPolicy | PolicyStatus) {
    if (typeof policyOrStatus === 'string') {
      return Util.formatPolicyStatus(policyOrStatus);
    }
    return Util.formatPolicyStatus(policyOrStatus.status);
  }

  formatStatusClass(policyOrStatus: IPolicy | PolicyStatus) {
    if (typeof policyOrStatus === 'string') {
      return Util.formatPolicyStatusClass(policyOrStatus);
    }

    return Util.formatPolicyStatusClass(policyOrStatus.status);
  }

  formatTaskStatus(task: ITask | TaskStatus) {
    if (typeof task === 'string') {
      return Util.formatTaskStatus(task);
    }

    return Util.formatTaskStatus(task.status);
  }
  formatTaskStatusClass(task: ITask | TaskStatus) {
    if (typeof task === 'string') {
      return Util.formatTaskStatusClass(task);
    }

    return Util.formatTaskStatusClass(task.status);
  }

  formatDate(date: Date) {
    return Util.formatDateSimple(date);
  }

  formatDateSemiLong(date: Date) {
    return Util.formatDateSemiLong(date);
  }

  formatCurrency(value?: number) {
    if (!value) {
      return '-';
    }

    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
  }

  userFullName(user: IUser) {
    if (!user || !user.id || user.id === '') {
      return 'Nicht zugewiesen';
    }

    if (!user.lastname) {
      return user.firstname;
    }

    if (!user.firstname) {
      return user.lastname;
    }
    return `${user.lastname}, ${user.firstname}`;
  }
}
